import React, { useState } from "react";
import Icon from "components/AppIcon";

const AIAmplificationOpportunities = ({ opportunities }) => {
  const [expanded, setExpanded] = useState(0);

  return (
    <section className="bg-white rounded-2xl border border-[rgba(40,59,163,0.10)] shadow-sm p-6 md:p-8 lg:p-10">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: "rgba(40,59,163,0.08)" }}>
          <Icon name="Zap" size={22} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <div>
          <p className="text-xs font-medium uppercase tracking-widest" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Section 2</p>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>AI Amplification Opportunities</h2>
        </div>
      </div>
      <p className="text-sm md:text-base mb-6" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-body)" }}>
        Three specific ways AI tools can multiply your existing expertise — turning what you already know into scalable income streams.
      </p>
      <div className="flex flex-col gap-4">
        {opportunities?.map((opp, idx) => (
          <div key={idx} className="rounded-xl border overflow-hidden transition-all duration-250" style={{ borderColor: expanded === idx ? "var(--color-primary)" : "var(--color-border)" }}>
            <button
              type="button"
              className="w-full flex items-center justify-between p-4 md:p-5 text-left"
              style={{ backgroundColor: expanded === idx ? "rgba(40,59,163,0.04)" : "var(--color-surface)" }}
              onClick={() => setExpanded(expanded === idx ? -1 : idx)}
              aria-expanded={expanded === idx}
            >
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold" style={{ backgroundColor: "var(--color-primary)", color: "#fff", fontFamily: "var(--font-data)" }}>
                  {idx + 1}
                </div>
                <span className="text-sm md:text-base font-semibold truncate" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)", fontWeight: 700 }}>{opp?.title}</span>
              </div>
              <Icon name={expanded === idx ? "ChevronUp" : "ChevronDown"} size={18} color="var(--color-muted-foreground)" strokeWidth={2} className="flex-shrink-0 ml-2" />
            </button>

            {expanded === idx && (
              <div className="px-4 md:px-5 pb-5 pt-2 border-t" style={{ borderColor: "var(--color-border)" }}>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                  <div className="rounded-lg p-3" style={{ backgroundColor: "rgba(211,172,53,0.08)" }}>
                    <p className="text-xs font-semibold uppercase tracking-wide mb-1" style={{ color: "var(--color-accent)", fontFamily: "var(--font-caption)" }}>Income Model</p>
                    <p className="text-sm" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-body)" }}>{opp?.incomeModel}</p>
                  </div>
                  <div className="rounded-lg p-3" style={{ backgroundColor: "rgba(40,59,163,0.05)" }}>
                    <p className="text-xs font-semibold uppercase tracking-wide mb-1" style={{ color: "var(--color-primary)", fontFamily: "var(--font-caption)" }}>Who It Serves</p>
                    <p className="text-sm" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-body)" }}>{opp?.whoItServes}</p>
                  </div>
                  <div className="rounded-lg p-3" style={{ backgroundColor: "rgba(40,59,163,0.05)" }}>
                    <p className="text-xs font-semibold uppercase tracking-wide mb-1" style={{ color: "var(--color-success)", fontFamily: "var(--font-caption)" }}>How AI Helps Scale</p>
                    <p className="text-sm" style={{ color: "var(--color-foreground)", fontFamily: "var(--font-body)" }}>{opp?.howAIHelps}</p>
                  </div>
                </div>
                <div className="mt-3 flex items-center gap-2">
                  <Icon name="TrendingUp" size={14} color="var(--color-success)" strokeWidth={2} />
                  <p className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                    Estimated monthly potential: <span className="font-semibold" style={{ color: "var(--color-success)" }}>{opp?.estimatedIncome}</span>
                  </p>
                </div>
                <div className="mt-1 flex items-center gap-2">
                  <Icon name="Zap" size={14} color="var(--color-primary)" strokeWidth={2} />
                  <p className="text-xs" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
                    AI scaling: <span className="font-semibold" style={{ color: "var(--color-primary)" }}>(multiply estimated monthly 2–4 times)</span>
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default AIAmplificationOpportunities;